// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__11ERp","item":"PaymentsMobile_item__11Pem","label":"PaymentsMobile_label__Osm1e","amount":"PaymentsMobile_amount__1A34N"};